import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import "./App.css";

// Common Components
import ScrollTop from "./components/common/ScrollTop";
import Loader from "./components/common/Loader";

// Lazy Load Pages for Better Performance
const Home = lazy(() => import("./pages/Home"));
 
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <BrowserRouter>
      {/* Scroll to top on route change */}
      <ScrollTop />

      {/* Suspense for lazy loading with fallback loader */}
      <Suspense fallback={<Loader />}>
        <AnimatePresence mode="wait">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            

            {/* 404 - Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;